import { useState } from 'react';
import { Alert, Box, Button, Stack, TextField, Typography } from '@mui/material';
import type { ExtractedQuestion } from '@/types/pipeline';

interface Props {
  question: ExtractedQuestion;
  onConfirm: (confirmed: ExtractedQuestion) => void;
}

export function EssayQuestionConfirm({ question, onConfirm }: Props) {
  const isEmpty = !question.questionText.trim();
  const [editing, setEditing] = useState(isEmpty);
  const [draft, setDraft] = useState(question.questionText);

  const handleConfirm = () => {
    onConfirm({ ...question, questionText: draft });
    setEditing(false);
  };

  const handleCancelEdit = () => {
    setDraft(question.questionText);
    setEditing(false);
  };

  if (editing) {
    return (
      <Stack spacing={1}>
        {isEmpty && (
          <Alert severity="warning" sx={{ py: 0.5, fontSize: '0.8125rem' }}>
            未偵測到題目文字，請手動輸入。
          </Alert>
        )}
        <TextField
          multiline
          minRows={4}
          fullWidth
          size="small"
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          inputProps={{ style: { fontSize: '0.8125rem' } }}
          placeholder="請輸入作文題目（選作指示 + 所有命題 + 字數要求）"
        />
        <Stack direction="row" spacing={1}>
          <Button
            size="small"
            variant="contained"
            disabled={!draft.trim()}
            onClick={handleConfirm}
          >
            確認
          </Button>
          {!isEmpty && (
            <Button size="small" variant="outlined" onClick={handleCancelEdit}>取消</Button>
          )}
        </Stack>
      </Stack>
    );
  }

  return (
    <Stack spacing={1}>
      <Box
        sx={{
          p: 1,
          bgcolor: 'grey.50',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          fontSize: '0.8125rem',
          whiteSpace: 'pre-wrap',
          color: 'text.secondary',
          maxHeight: 200,
          overflow: 'auto',
        }}
      >
        {question.questionText}
      </Box>
      <Stack direction="row" spacing={1}>
        <Button
          size="small"
          variant="contained"
          onClick={() => onConfirm({ ...question, questionText: question.questionText })}
        >
          確認
        </Button>
        <Button size="small" variant="outlined" onClick={() => setEditing(true)}>修改</Button>
      </Stack>
    </Stack>
  );
}
